import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import find from 'lodash/find';

import Breadcrumbs from 'containers/Breadcrumbs/Breadcrumbs';
import * as type from 'store/actions/types';
import { layouts, route } from 'config/constants';
import { isLoggedOut } from '../../helpers/accountHelper';
import routes from '../../config/routes';

export default class Content extends Component {
  UNSAFE_componentWillMount() {
    this.detectLayout(this.props);
    this.props.dispatch({
      type: type.SET_APP_PATH,
      payload: this.props.component.props.path,
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.detectLayout(nextProps);
  }

  detectLayout = (props) => {
    let { layout } = props.app;
    let { dispatch } = props;
    if (layout !== props.layout) {
      dispatch({ type: type.SET_APP_LAYOUT, payload: props.layout });
    }
  };

  getSwitchPage = () => {
    let switchPage;
    const { path } = this.props.component.props;
    const { t } = this.props;

    switch (path) {
      case route.CREATE_PROFILE: {
        switchPage = (
          <div className="layout-sign-switch layout-sign-switch-create-profile">
            {t('content:alreadyHaveAUserProfile')}{' '}
            <Link to={route.START}>{t('content:logInHere')}</Link>.
          </div>
        );
        break;
      }
      case route.RESET_PASSWORD: {
        switchPage = (
          <div className="layout-sign-switch">
            {t('content:rememberYourPassword')}{' '}
            <Link to={route.START}>{t('content:logInHere')}</Link>.
          </div>
        );
        break;
      }
      default:
        break;
    }
    return switchPage;
  };

  hasParentRoutes = () => {
    var path = this.props.component.props.computedMatch.path;
    var currentRoute = find(routes, { path: path });
    return currentRoute && currentRoute.innerRoutePaths && currentRoute.innerRoutePaths.length > 0;
  };

  render() {
    const { component, app, currentUser } = this.props;
    switch (app.layout) {
      case layouts.SIGN: {
        return (
          <>
            {component}
            {this.getSwitchPage()}
          </>
        );
      }
      case layouts.DASHBOARD: {
        var showBreadcrumbs = !isLoggedOut(currentUser) && this.hasParentRoutes();
        var wrapperClass = showBreadcrumbs ? 'has-breadcrumbs' : '';
        return (
          <div style={{ height: '100%' }} className={wrapperClass}>
            {showBreadcrumbs && (
              <Breadcrumbs
                path={component.props.computedMatch.path}
                params={component.props.computedMatch.params}
              />
            )}
            {component}
          </div>
        );
      }
      default:
        return component;
    }
  }
}
